module.exports = __webpack_public_path__ + "static/media/car.17cc369f.svg";